module.exports = __webpack_public_path__ + "static/media/bird_fly08.94924fc7.gif";